import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-container",
  tabindex: "0",
  role: "alert"
}
const _hoisted_2 = ["id"]



interface Props {
  error: string;
  id: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'agilaFormError',
  props: {
    error: { default: "" },
    id: { default: undefined }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (props.error)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (props.error)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "agila-icon-error" }, null, -1)),
              _createElementVNode("span", {
                id: props.id
              }, _toDisplayString(props.error), 9, _hoisted_2)
            ], 64))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})